import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";
const theme = createTheme();

const useExamProfileSectionStyle = makeStyles(() => ({
  profileSection: {
    height: "95vh !important",
    padding: "1rem 0.8rem !important",
    boxShadow: "0px 8px 15px #D7DAF2 !important",
    zIndex: "1200 !important",
  },
  profilesectioninner: {
    display: "flex !important",
    justifyContent: "space-between !important",
  },
  imagecontainer: {
    width: " 40%",
    display: "flex",
    background: "#E0E0E2",
    borderRadius: "10px",
  },
  profilephoto: {
    aspectRatio: "1 / 1",
    borderRadius: "10px",
  },
  learnerinfo: {
    marginLeft: "0.5rem",
    "& .MuiTypography-body1": {
      color: "#000",
      fontFamily: "Plus Jakarta Sans",
      fontSize: "1rem",
      fontStyle: "normal",
      fontWeight: "600",
      textTransform: "capitalize",
      TextTrack: "wrap",
    },
    "& .MuiTypography-body2": {
      color: "#000",
      fontFamily: "Satoshi",
      fontSize: "0.9rem",
      fontStyle: "normal",
      fontWeight: "500",
      textTransform: "capitalize",
    },
  },
  questionpallatemain: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  timer: {
    width: "80%",
    background: "#4565B7",
    borderRadius: "10px",
    padding: "0.7rem",
    margin: "0.5rem 0",
    textAlign: "center",
    "& .MuiTypography-h4": {
      color: "#FFF",
      fontFamily: "Playfair Display",
      fontSize: "0.875rem",
      fontStyle: "normal",
      fontWeight: "800",
      textTransform: "capitalize",
    },
  },
  numberbox: {
    background: "#F0F2FF",
    width: "80%",
    padding: "0.4rem",
    borderRadius: "6px",
    margin:'auto '
  },
  numberboxhead: {
    background: "#4565B7",
    borderRadius: "6px 6px 0px 0px",
    padding: "0.7rem",
    "& .MuiTypography-h4": {
      color: "#FFF",
      fontFamily: "Playfair Display",
      fontSize: "0.875rem",
      fontStyle: "normal",
      fontWeight: "800",
      textTransform: "capitalize",
    },
  },
  questionNumberBoxmain: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    height: "40vh",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "8px",
    },

    /* Track */
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 5px grey",
      borderRadius: "10px",
    },

    /* Handle */
    "&::-webkit-scrollbar-thumb": {
      background: "#4565B7",
      borderRadius: "10px",
    },

    /* Handle on hover */
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#39476B",
    },
  },
  questionNumberBoxmaininner: {
    width: "95%",
    height: "20px",
    display: "grid",
    padding:'0.5rem 0rem',
    gridTemplateColumns: "repeat(auto-fill, minmax(28px, 1fr))", // Adjust minmax as needed
    gap: "0.5rem", // Replace margin with gap
  },
  questionNumberBox: {
    minWidth: "28px !important", // Increased from 28px
    minHeight: "28px !important", // Increased from 28px
    width: "28px !important", // Fixed width
    height: "28px !important", // Increased from 28px
    padding: "0 !important",
    margin: "0 !important", // Remove individual margins
    backgroundColor: "#D7DAF2",
    borderRadius: "5px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
    "&.selected": {
      backgroundColor: "#4565B7",
      color: "white",
      fontWeight: "bold",
    },
    "&.attempted": {
      backgroundColor: "#04A10B",
      color: "white",
      fontWeight: "bold",
    },
    "&.markedWithAnswered": {
      backgroundColor: "yellow",
      color: "black",
      fontWeight: "bold",
    },
    "&.notAnswered": {
      backgroundColor: "#F26809",
      color: "white",
      fontWeight: "bold",
    },
    "&.notVisited": {
      backgroundColor: "#D7DAF2",
      color: "black",
      // fontWeight: "bold",
    },
    "&.marked": {
      background: "Purple",
      color: "white",
      fontWeight: "bold",
    },
  },
  selectedQuestion: {
    width: "125px",
    margin: "0 0.5rem",
    padding: "0.5rem",
    background: "#4565B7",
    borderRadius: "6px",
    color: "#FFF",
    fontFamily: "'Jost', sans-serif",
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    textTransform: "capitalize",
    border: "1px solid  #4565B7",
    boxShadow: "none",
    boxShadow:
      "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
    "&:hover": {
      background: "#4565B7",
    },
  },
  bgwhite: {
    // height: "40vh",
    background: "white",
    border: "1px solid #D7DAF2",
    borderRadius: "6px",
  },
  legend: {
    width: "100%",
    marginTop: "0.5rem",
    display: "flex",
    flexWrap: "wrap",
    margin:'auto'
  },
  legendinner2: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    marginTop: "0.1rem",
    "& .MuiTypography-body1": {
      color: "#727272",
      fontSize: "0.9rem",
      fontFamily: "'Jost', sans-serif",
      fontWeight: "400",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
    },
    "& span": {
      margin: "0.2rem",
      minWidth: "15px",
      minHeight: "15px",
    },
  },
  attempted: {
    background: "#04A10B",
  },
  notanswered: {
    background: "#F26809",
  },
  markedanswer: {
    background: "yellow",
  },
  markednotanswer: {
    background: "Purple",
  },
  notviewed: {
    background: "#D7DAF2",
  },
  current: {
    backgroundColor: "#4565B7",
  },
  transparentbtn: {
    marginTop:'0.5rem !important',
    background: "#FFF !important",
    border: "1px solid  #00000 !important",
    margin: "0 1rem !important",
    color: "#000 !important",
    "&:hover": {
      background: "#4565B7",
      border: "1px solid  #4565B7",
      color: "#FFF",
    },
      "@media (min-width:769px) and (max-width:1100px)": {
      display: "none !important", // 📲 Tablet Portrait
    },
    // "@media (min-width:600px) and (max-width:768px)":{
    //   display: "none", 
    // }
  },
  //modalCSS
  modal: {
    display: "flex",
    alignItems: "flex-end",
    alignContent: "flex-end",
    justifyContent: "center",
    padding: theme.spacing(2),
    fontFamily: "'Jost', sans-serif",
  },
  modalContainer: {
    height: "87.5%",
    width: "95%",
    flexDirection: "column",
    alignItems: "center",
    flexWrap: "nowrap",
    backgroundColor: "#4565B7",
    margin: theme.spacing(1),
    padding: theme.spacing(2),
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalTitle: {
    fontFamily: "'Jost', sans-serif",
    color: `${theme.palette.background.paper}`,
  },
  modalButton: {
    fontFamily: "'Jost', sans-serif !important", 
    fontSize: "18px !important",
    fontWeight: "400 !important",
    backgroundColor: `${theme.palette.background.paper} !important`,
    color: "red !important",
    "&:hover": {
      backgroundColor: "red !important",
      color: `${theme.palette.background.paper} !important`,
    },
  },
  modalContent: {
    height: "85%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    overflow: "auto",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    "& img": {
      width: "100% !important",
      height: "auto !important",
      maxWidth: "100%", // Ensures responsiveness
    },
  },
}));

export default useExamProfileSectionStyle;
